import { Link } from "react-router-dom";

const steps = [
  {
    icon: "ri-search-eye-line",
    title: "按口味选分类",
    desc: "悬疑、推理、烧脑、反转、案件、解密六大分类，先锁定你偏好的推理类型。",
  },
  {
    icon: "ri-bookmark-line",
    title: "收藏到追更书架",
    desc: "把喜欢的作品加入书架，更新后在最新更新列表置顶标记，第一时间追更。",
  },
  {
    icon: "ri-sword-line",
    title: "跟随主角破局",
    desc: "边读边推理，留意每一处细节伏笔，和主角一起烧脑破解最终真相。",
  },
];

export default function TopicSection() {
  return (
    <section
      id="topic"
      className="w-full border-y border-background-200/60 bg-background-100"
    >
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          {/* 编辑特辑图 */}
          <div className="relative order-1 overflow-hidden rounded-lg border border-background-200/60">
            <img
              src="https://readdy.ai/api/search-image?query=detective%20study%20table%20with%20magnifying%20glass%2C%20old%20case%20files%2C%20crimson%20wax%20seal%2C%20warm%20gold%20desk%20lamp%20glow%2C%20dark%20noir%20atmosphere%2C%20stylized%20illustration%2C%20mystery%20theme%2C%20dramatic%20lighting&width=1400&height=1000&seq=topic-hanhan&orientation=landscape"
              alt="汗汗漫画推理追更专题配图"
              loading="lazy"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 to-transparent"></div>
            <div className="absolute bottom-4 left-4 right-4">
              <span className="inline-flex items-center gap-1 rounded-full bg-accent-500/90 px-3 py-1 text-xs font-semibold text-background-950">
                <i className="ri-sparkling-line" aria-hidden="true"></i>
                编辑特辑
              </span>
              <h3 className="mt-3 font-heading text-xl font-bold text-foreground-50 md:text-2xl">
                如何高效追更一部悬疑推理漫画？
              </h3>
            </div>
          </div>

          {/* 追更攻略 */}
          <div className="order-2">
            <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-3xl">
              一份给推理爱好者的
              <span className="mystery-text"> 追更攻略</span>
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-500">
              好的悬疑推理作品，值得一帧一帧细看。掌握下面的追更方法，
              让每一次阅读都能收获烧脑的乐趣与反转的惊喜。
            </p>

            <div className="mt-8 space-y-4">
              {steps.map((s, i) => (
                <div
                  key={s.title}
                  className="flex gap-4 rounded-lg border border-background-200/60 bg-background-900/40 p-4 md:p-5"
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-500/15 text-primary-400">
                    <i className={`${s.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <div>
                    <h4 className="font-heading text-base font-bold text-foreground-100">
                      <span className="mr-2 text-accent-400">0{i + 1}</span>
                      {s.title}
                    </h4>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-500">
                      {s.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/faq"
              className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-accent-300/50 px-6 py-3 text-sm font-semibold text-accent-300 transition-colors hover:bg-accent-500/10"
            >
              了解更多追更方式
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}